<!--
 * @APIAuthor:
 * @Descripttion:
 * @Author: jayne(罗敬)
 * @Date: 2021-06-29 11:50:19
 * @LastEditTime: 2025-11-24 14:53:59
-->
<template>
  <div class="hello">
    <h1 v-show="true">{{ msg }}</h1>
    <span v-if="developName == 'prod'">版本号:JYH5-V1.0.2 更新downLoad.vue页面的默认下载路径区分大陆和台湾</span>
    <span v-else-if="developName == 'test'">版本号:JYH5-V1.0.2-beta</span>
    <!-- <span v-else-if="developName == 'prodHY'">版本号:V2.0.1_TW_jyh5_250228 加入德国Medion工程版本</span> -->
    <span v-else-if="developName == 'prodHY'">版本号:V2.0.2_TW_jyh5_251124 更新downLoad.vue页面的默认下载路径区分大陆和台湾</span>
    <span v-else-if="developName == 'testHY'">版本号:V1.1.2_TW_jyh5_beta_0604 更新CoDoctor Home用户协议和隐私协议边距</span>
  </div>
</template>

<script>
import { developName } from "@/constans/urlConstans";
export default {
    name: "HelloWorld",
    data() {
        return {
            msg: "H5",
            developName,
        };
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1,
h2 {
    font-weight: normal;
}
ul {
    list-style-type: none;
    padding: 0;
}
li {
    display: inline-block;
    margin: 0 10px;
}
a {
    color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue